"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPValidationError = void 0;
class HTTPValidationError {
    constructor() {
    }
    static getAttributeTypeMap() {
        return HTTPValidationError.attributeTypeMap;
    }
}
exports.HTTPValidationError = HTTPValidationError;
HTTPValidationError.discriminator = undefined;
HTTPValidationError.attributeTypeMap = [
    {
        "name": "detail",
        "baseName": "detail",
        "type": "Array<ValidationError>",
        "format": ""
    }
];
//# sourceMappingURL=HTTPValidationError.js.map